export enum Permission {
  JoinPreview,
}

export const Permissions = {
  [Permission.JoinPreview]: ["developer", "manager"],
};
